export const lstXl = {
  parentBox: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  horizontalBox: {
    width: "100%",
    height: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  centerBox: {
    width: "30%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loginBox: {
    width: "90%",
    height: "90%",
    display: "flex",
    justifyContent: "center",
  },
  contentBox: {
    width: "100%",
  },
  imgBox: {
    height: "20%",
    display: "flex",
    justifyContent: "center",
  },
  imgSize: { width: "18vw" },

  loginTextBox: {
    mt: "3vh",
    display: "flex",
    justifyContent: "center",
  },
  loginText: {
    fontSize: "1.4vw",
    fontFamily: "MontserratSemiBold",
    color: "#858180",
  },
  secondaryTextBox: {
    display: "flex",
    justifyContent: "center",
  },
  secondaryText: {
    fontSize: ".7vw",
    fontFamily: "MontserratSemiBold",
    color: "#858180",
  },
  parentBoxUserField: {
    width: "100%",
    height: "15%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  userFieldBox: {
    width: "90%",
    height: "100%",
    borderRadius: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: 1,
    borderColor: "#cccccc",
  },
  userField: {
    width: "80%",
    fontFamily: "MontserratRegular",
    fontSize: ".8vw",
  },
  btnBox: {
    width: "100%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  signInBtn: {
    borderRadius: 10,
    height: "5vh",
    width: "13vw",
    textTransform: "initial",
    fontFamily: "MontserratMedium",
    fontSize: ".8vw",
  },
  forgotBox: {
    width: "100%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  forgotBtn: {
    textTransform: "initial",
    fontFamily: "MontserratSemiBold",
    fontSize: ".7vw",
    color: "#666666",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    backgroundColor: "#f3f6f9",
    fontFamily: "MontserratSemiBold",
    fontSize: ".6vw",
    color: "#808080",
    width: "100vw",
    height: "5vh",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  footerCenterText: { marginRight: "1vw", marginLeft: "1vw" },
};

export const lstLg = {
  parentBox: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  horizontalBox: {
    width: "100%",
    height: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  centerBox: {
    width: "30%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loginBox: {
    width: "90%",
    height: "90%",
    display: "flex",
    justifyContent: "center",
  },
  contentBox: {
    width: "100%",
  },
  imgBox: {
    height: "20%",
    display: "flex",
    justifyContent: "center",
  },
  imgSize: { width: "11vw" },

  loginTextBox: {
    mt: "3vh",
    display: "flex",
    justifyContent: "center",
  },
  loginText: {
    fontSize: "1.4vw",
    fontFamily: "MontserratSemiBold",
    color: "#858180",
  },
  secondaryTextBox: {
    display: "flex",
    justifyContent: "center",
  },
  secondaryText: {
    fontSize: ".7vw",
    fontFamily: "MontserratSemiBold",
    color: "#858180",
  },
  parentBoxUserField: {
    width: "100%",
    height: "15%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  userFieldBox: {
    width: "90%",
    height: "100%",
    borderRadius: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: 1,
    borderColor: "#cccccc",
  },
  userField: {
    width: "80%",
    fontFamily: "MontserratRegular",
    fontSize: ".8vw",
  },
  btnBox: {
    width: "100%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  signInBtn: {
    borderRadius: 10,
    height: "5vh",
    width: "13vw",
    textTransform: "initial",
    fontFamily: "MontserratMedium",
    fontSize: ".8vw",
  },
  forgotBox: {
    width: "100%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  forgotBtn: {
    textTransform: "initial",
    fontFamily: "MontserratSemiBold",
    fontSize: ".7vw",
    color: "#666666",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    backgroundColor: "#f3f6f9",
    fontFamily: "MontserratSemiBold",
    fontSize: ".6vw",
    color: "#808080",
    width: "100vw",
    height: "5vh",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  footerCenterText: { marginRight: "1vw", marginLeft: "1vw" },
};

export const lstMd = {
  parentBox: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  horizontalBox: {
    width: "100%",
    height: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  centerBox: {
    width: "40%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loginBox: {
    width: "90%",
    height: "90%",
    display: "flex",
    justifyContent: "center",
  },
  contentBox: {
    width: "100%",
  },
  imgBox: {
    height: "20%",
    display: "flex",
    justifyContent: "center",
  },
  imgSize: { width: "15vw" },

  loginTextBox: {
    mt: "3vh",
    display: "flex",
    justifyContent: "center",
  },
  loginText: {
    fontSize: "1.5vw",
    fontFamily: "MontserratSemiBold",
    color: "#858180",
  },
  secondaryTextBox: {
    display: "flex",
    justifyContent: "center",
  },
  secondaryText: {
    fontSize: "1vw",
    fontFamily: "MontserratSemiBold",
    color: "#858180",
  },
  parentBoxUserField: {
    width: "100%",
    height: "10%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  userFieldBox: {
    width: "90%",
    height: "100%",
    borderRadius: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: 1,
    borderColor: "#cccccc",
  },
  userField: {
    width: "80%",
    fontFamily: "MontserratRegular",
    fontSize: "1vw",
  },
  btnBox: {
    width: "100%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  signInBtn: {
    borderRadius: 10,
    height: "4vh",
    width: "16vw",
    textTransform: "initial",
    fontFamily: "MontserratMedium",
    fontSize: "1vw",
  },
  forgotBox: {
    width: "100%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  forgotBtn: {
    textTransform: "initial",
    fontFamily: "MontserratSemiBold",
    fontSize: "1vw",
    color: "#666666",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    backgroundColor: "#f3f6f9",
    fontFamily: "MontserratSemiBold",
    fontSize: "1vw",
    color: "#808080",
    width: "100vw",
    height: "5vh",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  footerCenterText: { marginRight: "1vw", marginLeft: "1vw" },
};
export const lstSm = {
  parentBox: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  horizontalBox: {
    width: "100%",
    height: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  centerBox: {
    width: "60%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loginBox: {
    width: "90%",
    height: "90%",
    display: "flex",
    justifyContent: "center",
  },
  contentBox: {
    width: "100%",
  },
  imgBox: {
    height: "20%",
    display: "flex",
    justifyContent: "center",
  },
  imgSize: { width: "20vw" },

  loginTextBox: {
    mt: "3vh",
    display: "flex",
    justifyContent: "center",
  },
  loginText: {
    fontSize: "3vw",
    fontFamily: "MontserratSemiBold",
    color: "#858180",
  },
  secondaryTextBox: {
    display: "flex",
    justifyContent: "center",
  },
  secondaryText: {
    fontSize: "2vw",
    fontFamily: "MontserratSemiBold",
    color: "#858180",
  },
  parentBoxUserField: {
    width: "100%",
    height: "10%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  userFieldBox: {
    width: "90%",
    height: "100%",
    borderRadius: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: 1,
    borderColor: "#cccccc",
  },
  userField: {
    width: "80%",
    fontFamily: "MontserratRegular",
    fontSize: "2vw",
  },
  btnBox: {
    width: "100%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  signInBtn: {
    borderRadius: 10,
    height: "4vh",
    width: "30vw",
    textTransform: "initial",
    fontFamily: "MontserratMedium",
    fontSize: "1.5vw",
  },
  forgotBox: {
    width: "100%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  forgotBtn: {
    textTransform: "initial",
    fontFamily: "MontserratSemiBold",
    fontSize: "2vw",
    color: "#666666",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    backgroundColor: "#f3f6f9",
    fontFamily: "MontserratSemiBold",
    fontSize: "2vw",
    color: "#808080",
    width: "100vw",
    height: "5vh",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  footerCenterText: { marginRight: "1vw", marginLeft: "1vw" },
};
export const lstXs = {
  parentBox: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  horizontalBox: {
    width: "100%",
    height: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  centerBox: {
    width: "80%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loginBox: {
    width: "90%",
    height: "90%",
    display: "flex",
    justifyContent: "center",
  },
  contentBox: {
    width: "100%",
  },
  imgBox: {
    height: "20%",
    display: "flex",
    justifyContent: "center",
  },
  imgSize: { width: "40vw" },

  loginTextBox: {
    mt: "3vh",
    display: "flex",
    justifyContent: "center",
  },
  loginText: {
    fontSize: "5vw",
    fontFamily: "MontserratSemiBold",
    color: "#858180",
  },
  secondaryTextBox: {
    display: "flex",
    justifyContent: "center",
  },
  secondaryText: {
    fontSize: "2.5vw",
    fontFamily: "MontserratSemiBold",
    color: "#858180",
  },
  parentBoxUserField: {
    width: "100%",
    height: "10%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  userFieldBox: {
    width: "100%",
    height: "100%",
    borderRadius: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: 1,
    borderColor: "#cccccc",
  },
  userField: {
    width: "80%",
    fontFamily: "MontserratRegular",
    fontSize: "3vw",
  },
  btnBox: {
    width: "100%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  signInBtn: {
    borderRadius: 10,
    height: "4vh",
    width: "40vw",
    textTransform: "initial",
    fontFamily: "MontserratMedium",
    fontSize: "2.5vw",
  },
  forgotBox: {
    width: "100%",
    mt: "2vh",
    display: "flex",
    justifyContent: "center",
  },
  forgotBtn: {
    textTransform: "initial",
    fontFamily: "MontserratSemiBold",
    fontSize: "3vw",
    color: "#666666",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    backgroundColor: "#f3f6f9",
    fontFamily: "MontserratSemiBold",
    fontSize: "3vw",
    color: "#808080",
    width: "100vw",
    height: "5vh",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  footerCenterText: { marginRight: "1vw", marginLeft: "1vw" },
};
